export const colors = {
  text: {
    primary: '#292929',
    secondary: '#474543',
    link: '#255A90',
  },
  theme: {
    blue: '#003366',
    // blueAlt: "#38598A",
    blueAlt: '#005C97',
    blueLight: '#ECF6FF',
    blueLightBg: '#E4F2FF',
    blueLight02: '#F1F8FE',
    blueButtonHover: '#1E5189',
    blueText: '#053662',
    primary100: '#234075',
    darkBlue: '#013366',
    radioOutline: '#0D6EFD',
    buttonHover: 'linear-gradient(0deg, rgba(0, 0, 0, 0.32) 0%, rgba(0, 0, 0, 0.32) 100%), #234075;',
    blueAltGradient: 'linear-gradient(124.8deg, #142B43 -52.7%, #142B43 -52.68%, #054277 47.38%, #142B43 137.55%)',
    bannerGradient:
      'conic-gradient(from 159.54deg at 73.72% 65.22%, rgba(12, 38, 64, 0) -77.34deg, #091521 166.15deg, rgba(12, 38, 64, 0) 282.66deg, #091521 526.15deg)',
    bannerTextShadow: '0px 0px 2px rgba(0, 0, 0, 0.2), 0px 5px 10px rgba(0, 0, 0, 0.2)',
    blueGradient:
      'var(--Gradient-Blue-Background, linear-gradient(125deg, #142B43 -52.7%, #142B43 -52.68%, #054277 47.38%, #142B43 137.55%))',
    blueImageGradient: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 12.92%, rgba(12, 38, 64, 0.80) 50.36%)',
    blueShadedDark: 'rgba(1, 51, 102, 0.90)',
    blueShadedLight: 'rgba(1, 51, 102, 0.40)',
    yellow: '#FCBA19',
    yellowLight: '#FEF2D6',
    green: '#61A744',
    lightGreen: '#F6FFF8',
    darkGreen: '#42814A',
    orange: '#F8BB47',
    orangeLight: '#FFFBF0',
    orangeLight02: '#FEF1D8',
    softRose: '#F4E1E2',
    // green: {
    //   100: "#F5FFF8",
    // },
  },
  background: {
    sandboxBase: '#FFC6CB',
    sandboxStripe: 'rgba(0, 0, 0, 0.1)',
  },
  greys: {
    overlay: 'rgba(150, 150, 150, 0.35)',
    white: '#FFFFFF',
    offWhite: '#F7F9FC',
    lightGrey: '#D8D8D8',
    grey01: '#A19F9D',
    grey02: '#E1DFDD',
    grey03: '#F2F2F2',
    grey04: '#FAF9F8',
    grey05: '#9F9D9C',
    grey10: '#FAF9F8',
    grey20: '#F3F2F1',
    grey50: '#D1CFCD',
    grey80: '#EDEBE9',
    grey90: '#3B3A39',
    grey100: '#1A1A1A',
    anotherGrey: '#2D2D2D',
    dividerGrey:'#898785',
    homeScreenGrey: '#474543',
  },
  border: {
    base: '#606060',
    dark: '#323130',
    light: '#D9D9D9',
    input: '#CCCCCC',
    randomBorderColorforthePublishModal: '#353433',
    homeScreenBorderColor: '#D8D8D8',
  },
  error: '#D9292F',
  success: '#2E8540',
  focus: '#2E5DD7',
  lighten: {
    100: 'rgba(255, 255, 255, 0.10)',
    900: 'rgba(255, 255, 255, 0.9);',
  },
  darken: {
    60: 'rgba(0, 0, 0, 0.06)',
    70: 'rgba(0, 0, 0, 0.07)',
    100: 'rgba(0, 0, 0, 0.1)',
  },
  hover: {
    blue: '#DFECF9',
  },
  semantic: {
    success: '#2E8540',
    successLight: '#D7F5DD',
    error: '#D9292F',
    errorLight: '#F7E1E3',
    errorDark: '#CE3E39',
    info: '#053662',
    infoLight: '#F7F9FC',
    // warning: "#FCBA19",
    warning: '#E86825',
    // warningLight: "#FEF2D6",
    warningLight: '#FEF8E8',
    special: '#8000FF',
    specialLight: '#F0DCFF',
  },
};
